import clsx from "clsx";

// Interfaces
import { ISideTreeCommons } from "../interfaces";

// Icons
import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

export default function SideTreeIcon(props: Readonly<ISideTreeCommons>) {
	const { selected = false, collapse = false, disabled = false } = props;

	if (!collapse && selected) {
		return <CircleRoundedIcon className="!text-primary !text-[14px]" />;
	}

	return (
		<ArrowForwardIosRoundedIcon
			className={clsx({
				"!text-[14px]": true,
				"!text-default": !disabled,
				"!text-disabled": disabled,
				"!rotate-90": collapse,
			})}
		/>
	);
}
